module.exports = __webpack_public_path__ + "static/media/landing-slide-5.ba238587.png";